// extracted by mini-css-extract-plugin
export default {"title":"ExpiredCard_title__4iR7J","haveAcc":"ExpiredCard_haveAcc__+MjS3","login":"ExpiredCard_login__vNbaa"};